var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"pt-0",attrs:{"dense":"","items":_vm.graus,"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"autofocus":_vm.autofocus,"clearable":true,"prepend-inner-icon":_vm.icon,"hide-details":_vm.hideDetails},model:{value:(_vm.grau),callback:function ($$v) {_vm.grau=$$v},expression:"grau"}})
}
var staticRenderFns = []

export { render, staticRenderFns }